import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import titleStyles from './Title.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const Title = React__default.forwardRef((_a, ref) => {
    var { size = "md", as: Comp = "h2", className, inverse = false, children } = _a, otherProps = __rest(_a, ["size", "as", "className", "inverse", "children"]);
    // Generate the class names based on the size variants
    const { base, leading } = titleStyles({
        size,
        inverse,
    });
    const finalClasses = cn(base(), leading(), className);
    // Render the heading component
    return (jsx(Comp, Object.assign({ ref: ref, className: finalClasses }, otherProps, { children: children })));
});
Title.displayName = "Title";

export { Title };
